import React, { useMemo } from 'react'
import { connect, shallowEqual, useSelector } from 'react-redux'
import PropTypes from 'prop-types'
import { Grid } from '@mui/material'
import i18n from 'simple-react-i18n'
import SubscriptionDto from '../dto/SubscriptionDto'
import ContributorDto from '../../../../referencial/components/contributor/dto/ContributorDto'
import Select from '../../../../components/forms/Select'
import Input from '../../../../components/forms/Input'
import Textarea from '../../../../components/forms/Textarea'
import { getMatTypes } from '../../../../utils/MaterielUtils'
import NetworkDto from '../../../../referencial/components/network/dto/NetworkDto'
import SubscriptionTypeDto from '../dto/SubscriptionTypeDto'
import { authorizeContributors, authorizeFilter } from 'utils/HabilitationUtil'
import User from 'account/dto/User'
import MultiContributorsAutocomplete from 'referencial/components/contributor/components/MultiContributorsAutocomplete'
import { SUBSCRIPTION_ID } from 'materiel/constants/MaterielConstants'
import { DATE_SERVICE_OBLIGATOIRE, NUMLINE_OBLIGATOIRE } from 'materiel/constants/MaterielSettingRuleConstant'
import { isFieldRequired } from 'materiel/utils/MaterielUtils'
import SimpleDatePicker from 'components/forms/SimpleDatePicker'

const SubscriptionsPanel = ({
    subscription = {},
    subscriptionTypes = [],
    active = false,
    disabled = true,
    contributors = [],
    accountUser = {},
    networks = [],
    onChange = () => { },
}) => {
    const {
        materielSettingRules,
    } = useSelector(store => ({
        materielSettingRules: store.MaterielReducer.materielSettingRules,
    }), shallowEqual)

    const rules = useMemo(() => {
        return materielSettingRules.filter(({ idMaterielType }) => idMaterielType === SUBSCRIPTION_ID)
    }, [materielSettingRules])

    return (
        <Grid container spacing={2} sx={{ marginBottom: '1rem' }}>
            <Grid size={4}>
                <Select
                    options={getMatTypes(subscriptionTypes, subscription.subscriptionType)}
                    label={i18n.subscriptionType}
                    onChange={v => onChange({ subscriptionType: v })}
                    value={subscription.subscriptionType}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                    obligatory
                />
            </Grid>
            <Grid size={4}>
                <MultiContributorsAutocomplete
                    options={authorizeContributors(contributors, accountUser, subscription.operatorCode)}
                    label={i18n.provider}
                    onChange={ope => onChange({ operatorCode: ope })}
                    values={subscription.operatorCode}
                    disabled={disabled}
                    keyLabel='labelDisplay'
                />
            </Grid>
            <Grid size={4}>
                <Input
                    title={i18n.lineNumber}
                    value={subscription.numLine}
                    onChange={value => onChange({ numLine: value })}
                    active={active}
                    disabled={disabled}
                    obligatory={isFieldRequired(rules, NUMLINE_OBLIGATOIRE)}
                />
            </Grid>
            <Grid size={12}>
                <Select
                    options={authorizeFilter(networks, accountUser, subscription.networkCode)}
                    label={i18n.network}
                    onChange={value => onChange({ networkCode: value })}
                    value={subscription.networkCode}
                    nullLabel='&nbsp;'
                    active={active}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    id='openingDate'
                    label={i18n.openDate}
                    value={subscription.openingDate}
                    onChange={v => onChange({ openingDate: v })}
                    max={subscription.closingDate}
                    disabled={disabled}
                    obligatory={isFieldRequired(rules, DATE_SERVICE_OBLIGATOIRE)}
                />
            </Grid>
            <Grid size={3}>
                <SimpleDatePicker
                    id='closingDate'
                    label={i18n.closeDateLine}
                    value={subscription.closingDate}
                    onChange={v => onChange({ closingDate: v })}
                    min={subscription.openingDate}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={3}>
                <Input
                    title={i18n.pathNumber}
                    value={subscription.numPath}
                    onChange={v => onChange({ numPath: v })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
            <Grid size={12}>
                <Textarea
                    title={i18n.comment}
                    value={subscription.comment}
                    onChange={value => onChange({ comment: value })}
                    active={active}
                    disabled={disabled}
                />
            </Grid>
        </Grid>
    )
}

SubscriptionsPanel.propTypes = {
    disabled: PropTypes.bool,
    active: PropTypes.bool,
    onChange: PropTypes.func,
    subscription: PropTypes.instanceOf(SubscriptionDto),
    subscriptionTypes: PropTypes.arrayOf(PropTypes.instanceOf(SubscriptionTypeDto)),
    contributors: PropTypes.arrayOf(PropTypes.instanceOf(ContributorDto)),
    networks: PropTypes.arrayOf(PropTypes.instanceOf(NetworkDto)),
    accountUser: PropTypes.instanceOf(User),
}

const mapStateToProps = store => ({
    contributors: store.ContributorReducer.contributors,
    subscriptionTypes: store.SubscriptionReducer.subscriptionTypes,
    networks: store.NetworkReducer.networks,
    accountUser: store.AccountReducer.accountUser,
})

export default connect(mapStateToProps)(SubscriptionsPanel)
